package szlot

/**
 * Frontend controller for the greeter scene; the base class comes from KSP.
 *
 * Originally scaffolded by `./gradlew :app:generateVisageScaffolds`.
 */
class GreeterControllerFe(props: GreeterProps, scene: MGreeterScene) :
    AGreeterControllerFe(props, scene) {

    override fun createInitialModel(): GreeterModel = GreeterModel(props.title)

    override fun init() {
        // Round-trip to the JVM backend; the returned model re-renders the scene.
        call_greet("szlot")
    }
}
